export default __webpack_public_path__ + "static/media/illustration-industrial.43d0976c.png";